import { Box, Button, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { IoPersonOutline } from "react-icons/io5";

export type PreviewMode = "mobile" | "desktop";

const PalommaDisclaimerPreview = () => (
  <HStack gap={1}>
    <svg
      width="12"
      height="12"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.2411 15.2449C27.2411 15.2449 28.7877 12.5442 28.1727 10.5782C28.1475 10.4956 28.1188 10.4164 28.0919 10.3372C28.0649 10.2614 28.0363 10.1873 28.006 10.1132C27.2916 8.37453 25.6018 7.23228 23.7267 7.10761L21.4119 6.9543L21.2586 4.63947C21.1339 2.76436 19.9917 1.07457 18.253 0.360247C18.1789 0.329922 18.1048 0.301281 18.029 0.274326C17.9498 0.24737 17.8706 0.218729 17.788 0.193458C15.822 -0.42147 13.1213 1.12512 13.1213 1.12512L0.366211 7.80003C1.53036 9.98176 4.17371 10.8747 6.40767 9.88573C6.4481 9.97671 6.49022 10.066 6.53739 10.1553C7.70997 12.3977 10.4392 13.2973 12.7069 12.2241C12.8113 13.0615 13.182 13.8718 13.8239 14.5137C14.4657 15.1556 15.3014 15.538 16.1522 15.6357C15.0621 17.9084 15.9618 20.6512 18.2109 21.8288C18.3002 21.876 18.3895 21.9181 18.4805 21.9585C17.4915 24.1908 18.3844 26.8358 20.5662 28L27.2411 15.2449Z"
        fill="#4012AB"
      />
    </svg>
    <Text fontSize="8px" color="#4012AB">
      Pagos seguros por Palomma
    </Text>
  </HStack>
);

const LoginPanelPreview = ({ logoUrl }: { logoUrl?: string }) => (
  <VStack
    justify="space-evenly"
    gap={1}
    px={3}
    py={2.5}
    bg="white"
    width="100%"
    height="100%"
  >
    <Box width="65%" height="32px" minWidth="40px">
      {logoUrl ? (
        <Image src={logoUrl} width="100%" height="100%" objectFit="contain" />
      ) : (
        <Text
          fontSize="xs"
          color="gray.400"
          textAlign="center"
          lineHeight="32px"
        >
          Tu logo
        </Text>
      )}
    </Box>
    <VStack gap={0}>
      <Text fontSize="xs" fontWeight={500} textAlign="center" lineHeight="1.2">
        Bienvenido al Sistema de Recaudos
      </Text>
      <Text fontSize="10px" color="gray.500">
        Realiza pagos de manera segura
      </Text>
    </VStack>
    <VStack gap={1} width="90%">
      <HStack
        width="100%"
        height="24px"
        borderWidth="1px"
        borderColor="gray.300"
        borderRadius="sm"
        overflow="hidden"
        gap={0}
      >
        <Box
          px={1.5}
          height="100%"
          display="flex"
          alignItems="center"
          borderRightWidth="1px"
          borderColor="gray.300"
          color="#1D1840"
        >
          <IoPersonOutline size={11} />
        </Box>
        <Text fontSize="9px" color="gray.400" px={1.5}>
          Número de documento
        </Text>
      </HStack>
      <Box
        width="100%"
        bg="#1D1840"
        color="white"
        borderRadius="sm"
        py={1}
        textAlign="center"
        fontSize="9px"
        fontWeight={600}
      >
        INICIAR SESIÓN
      </Box>
    </VStack>
    <PalommaDisclaimerPreview />
  </VStack>
);

const PREVIEW_SCALE = 0.5;
export const PREVIEW_HEIGHT = 240;
export const PREVIEW_FRAME_WIDTH = 360;
const MOBILE_PREVIEW_WIDTH = 148;

export const DesktopPortalPreview = ({
  logoUrl,
  imageSrc,
}: {
  logoUrl?: string;
  imageSrc: string;
}) => (
  <Box
    borderWidth="1px"
    borderColor="gray.200"
    borderRadius="lg"
    overflow="hidden"
    height={`${PREVIEW_HEIGHT}px`}
    width="100%"
    position="relative"
    bg="gray.50"
  >
    <HStack
      position="absolute"
      top={0}
      left={0}
      gap={0}
      align="stretch"
      width={`${100 / PREVIEW_SCALE}%`}
      height={`${PREVIEW_HEIGHT / PREVIEW_SCALE}px`}
      transform={`scale(${PREVIEW_SCALE})`}
      transformOrigin="top left"
    >
      <Box width="50%" bg="gray.100">
        <Image src={imageSrc} width="100%" height="100%" objectFit="cover" />
      </Box>
      <Box width="50%" bg="white" display="flex" justifyContent="center">
        <Box width="340px" maxWidth="100%" height="100%">
          <LoginPanelPreview logoUrl={logoUrl} />
        </Box>
      </Box>
    </HStack>
  </Box>
);

export const MobilePortalPreview = ({
  logoUrl,
  imageSrc,
}: {
  logoUrl?: string;
  imageSrc: string;
}) => (
  <Box
    borderWidth="1px"
    borderColor="gray.200"
    borderRadius="lg"
    overflow="hidden"
    width={`${MOBILE_PREVIEW_WIDTH}px`}
    height={`${PREVIEW_HEIGHT}px`}
    position="relative"
    flexShrink={0}
  >
    <Box
      position="absolute"
      top={0}
      left={0}
      width={`${MOBILE_PREVIEW_WIDTH / PREVIEW_SCALE}px`}
      height={`${PREVIEW_HEIGHT / PREVIEW_SCALE}px`}
      transform={`scale(${PREVIEW_SCALE})`}
      transformOrigin="top left"
    >
      <Image
        src={imageSrc}
        position="absolute"
        inset={0}
        width="100%"
        height="100%"
        objectFit="cover"
      />
      <Box
        position="absolute"
        left="50%"
        top="50%"
        transform="translate(-50%, -50%)"
        width="85%"
        bg="white"
        borderRadius="16px"
        boxShadow="lg"
        overflow="hidden"
        height="78%"
      >
        <LoginPanelPreview logoUrl={logoUrl} />
      </Box>
    </Box>
  </Box>
);

export const PreviewToggle = ({
  value,
  onChange,
  disabled,
}: {
  value: PreviewMode;
  onChange: (value: PreviewMode) => void;
  disabled?: boolean;
}) => (
  <HStack
    gap={0}
    borderWidth="1px"
    borderColor="gray.200"
    borderRadius="md"
    overflow="hidden"
    width="fit-content"
  >
    {(
      [
        { id: "mobile", label: "Móvil" },
        { id: "desktop", label: "Escritorio" },
      ] as const
    ).map((option) => {
      const active = value === option.id;
      return (
        <Button
          key={option.id}
          size="xs"
          variant="ghost"
          borderRadius="0"
          px={3}
          bg={active ? "gray.100" : "transparent"}
          fontWeight={active ? 600 : 400}
          color={active ? "gray.800" : "gray.500"}
          disabled={disabled}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </Button>
      );
    })}
  </HStack>
);
